module.exports = __webpack_public_path__ + "img/paymentbackground.19b87e37.png";